import { PlatformLocation } from '@angular/common';
import { Injectable } from '@angular/core';
import { OfficeHomePageErrorHandler } from '../error-handler/error-handler.service';
import { OfficeRoute } from '../shared/constants/office-route.enum';
import { InstrumentationService } from '../shared/instrumentation/instrumentation.service';
import { InstrumentedHttp } from '../shared/instrumentation/instrumented-http.service';
import { MruConfigService } from '../shared/mru/mru-config.service';
import { AccessTokenService } from '../shared/services/access-token.service';
import { DateService } from '../shared/services/date.service';
import { OfficeRouteItem, OfficeRouteService } from '../shared/services/office-route.service';
import { OfficeHomeApiConfigService } from '../shared/services/officehome-api-config.service';
import { SchedulerService } from '../shared/services/scheduler.service';
import { UpdateContentService } from '../shared/services/update-content.service';
import { WindowService } from '../shared/services/window.service';
import { CapabilitiesService } from '../shared/shared-context/capabilities.service';
import { ClientStartupConfigService } from '../shared/shared-context/client-startup-config.service';
import { ContextService } from '../shared/shared-context/context.service';
import { LocService } from '../shared/shared-context/loc.service';
import { OfficeFeedDataService } from './officefeed-data.service';
import { OfficeFeedV2Service } from './officefeed-v2.service';

@Injectable({
    providedIn: 'root'
})
export class OfficeFeedFactoryService {
    private readonly officefeedService: OfficeFeedDataService;

    constructor(
        accessTokenService: AccessTokenService,
        instrumentedHttp: InstrumentedHttp,
        instrumentationService: InstrumentationService,
        contextService: ContextService,
        officeHomeApiConfigService: OfficeHomeApiConfigService,
        mruConfigService: MruConfigService,
        platformLocation: PlatformLocation,
        globalErrorHandler: OfficeHomePageErrorHandler,
        startupConfigservice: ClientStartupConfigService,
        officeRouteService: OfficeRouteService,
        updateContentService: UpdateContentService,
        scheduler: SchedulerService,
        capabilitiesService: CapabilitiesService,
        locService: LocService,
        dateService: DateService,
        windowService: WindowService
    ) {
        this.officefeedService = new OfficeFeedV2Service(accessTokenService, capabilitiesService, contextService, instrumentationService, instrumentedHttp, locService, officeHomeApiConfigService, mruConfigService, platformLocation, globalErrorHandler, startupConfigservice, updateContentService, scheduler, dateService, windowService);

        officeRouteService.subscribeToRouteChangeStart(event => {
            if (event.currentRoute && (mruConfigService.config.officeFeedControlEnabled || mruConfigService.config.officeFeedFlightEnabled)) {
                this.warmDocumentCache(event.currentRoute);
            }
        });
    }

    public getOfficeFeedService() {
        return this.officefeedService;
    }

    private warmDocumentCache(routeItem: OfficeRouteItem) {
        switch (routeItem.route) {
            case OfficeRoute.OfficeHome:
            case OfficeRoute.Pwa:
                this.officefeedService.getOfficeFeed();
                break;
        }
    }
}
